import * as A from "react";
import r from "react";
import { jsx as u } from "react/jsx-runtime";
import { c as O, u as S, S as I } from "./index-Bm60c36x.js";
var y = A.createContext(void 0);
function L(l) {
  const i = A.useContext(y);
  return l || i || "ltr";
}
function g(l) {
  const i = l + "CollectionProvider", [N, _] = O(i), [v, f] = N(
    i,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), m = (c) => {
    const { scope: e, children: s } = c, t = r.useRef(null), o = r.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ u(v, { scope: e, itemMap: o, collectionRef: t, children: s });
  };
  m.displayName = i;
  const d = l + "CollectionSlot", p = r.forwardRef(
    (c, e) => {
      const { scope: s, children: t } = c, o = f(d, s), n = S(e, o.collectionRef);
      return /* @__PURE__ */ u(I, { ref: n, children: t });
    }
  );
  p.displayName = d;
  const C = l + "CollectionItemSlot", R = "data-radix-collection-item", x = r.forwardRef(
    (c, e) => {
      const { scope: s, children: t, ...o } = c, n = r.useRef(null), M = S(e, n), a = f(C, s);
      return r.useEffect(() => (a.itemMap.set(n, { ref: n, ...o }), () => void a.itemMap.delete(n))), /* @__PURE__ */ u(I, { [R]: "", ref: M, children: t });
    }
  );
  x.displayName = C;
  function E(c) {
    const e = f(l + "CollectionConsumer", c);
    return r.useCallback(() => {
      const t = e.collectionRef.current;
      if (!t) return [];
      const o = Array.from(t.querySelectorAll(`[${R}]`));
      return Array.from(e.itemMap.values()).sort(
        (a, T) => o.indexOf(a.ref.current) - o.indexOf(T.ref.current)
      );
    }, [e.collectionRef, e.itemMap]);
  }
  return [
    { Provider: m, Slot: p, ItemSlot: x },
    E,
    _
  ];
}
export {
  g as c,
  L as u
};
